module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-text-96bb32a6373a0ba8e26bb4709f9cc2e5.png";